import { render } from "./AvailmentSOAIndex.vue?vue&type=template&id=70337b8a"
import script from "./AvailmentSOAIndex.vue?vue&type=script&lang=js"
export * from "./AvailmentSOAIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__